import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.clearError.bind(this))
  }

  clearError() {
    // Remove red border from the input itself
    this.element.classList.remove("is-invalid")

    // Find and hide the sibling error message (Simple Form renders "invalid-feedback")
    const wrapper = this.element.closest(".mb-3")
    if (wrapper) {
      const feedback = wrapper.querySelector(".invalid-feedback")
      if (feedback) feedback.classList.add("d-none")
    }
  }
}
